(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 59588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _components_Login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17826);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useUser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14917);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);





function Home() {
  var _router$query;

  var _useUser = (0,_hooks_useUser__WEBPACK_IMPORTED_MODULE_3__/* .useUser */ .a)(),
      user = _useUser.user,
      userLoading = _useUser.userLoading;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  var signUp = !!((_router$query = router.query) !== null && _router$query !== void 0 && _router$query.signUp);
  var linkWithAcc = router.query; // Listen for changes on loading and authUser, redirect if needed

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      checkedUserOnArrival = _useState[0],
      setCheckedUserOnArrival = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (!userLoading && !checkedUserOnArrival) {
      if (user !== null && user !== void 0 && user.uid) {// router.push("/videos/create")
      }

      setCheckedUserOnArrival(true);
    }
  }, [router, user, userLoading]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
    className: "w-screen h-screen bg-twitter-500 flex place-content-center",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_Login__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      defaultSigningUp: signUp
    })
  });
}

/***/ }),

/***/ 83236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(59588);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [661,5445,3247,7421,3426,808,7512,7197,7826,9774,2888,179], function() { return __webpack_exec__(83236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);